import React from 'react';
import './App.css';
import PropTypes from 'prop-types';


class Icon extends React.Component {
  render() {
  return (
  	 <div>
     <header>
      <div className="image-container">
       <a href={this.props.link} target="_blank" rel="noopener noreferrer"> <img className="logo_img" src={this.props.URL} alt="img-URL" title={this.props.hover} /> {this.props.id} </a>
      </div>
      </header>
    </div>
  );
}}
Icon.propTypes = {
  IconURL:PropTypes.string.isRequired,
};

export default Icon;